import { render, staticRenderFns } from "./RecipientsSection.vue?vue&type=template&id=045879dd"
import script from "./RecipientsSection.vue?vue&type=script&lang=js"
export * from "./RecipientsSection.vue?vue&type=script&lang=js"
import style0 from "./RecipientsSection.vue?vue&type=style&index=0&id=045879dd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports